/**
 * Shared midterm chrome. Colours go through Neutral / surface tokens so
 * light and dark both read; do not use Tailwind `dark:` (OS preference).
 */

export const INK = 'text-Neutral-5'
export const MUTED = 'text-Neutral-4'
export const FAINT = 'text-Neutral-4/80 [html[data-theme=\'dark\']_&]:text-white/55'

export const CARD =
  'rounded-lg border border-Neutral-3 bg-surface-2 [html[data-theme=\'dark\']_&]:bg-white/[0.06] [html[data-theme=\'dark\']_&]:backdrop-blur-xl'

export const CARD_HOVER = 'hover:bg-Neutral-2 [html[data-theme=\'dark\']_&]:hover:bg-white/[0.11]'

export const GLASS_FILL = 'bg-Neutral-3/55 [html[data-theme=\'dark\']_&]:bg-white/[0.07]'

export const TAB_ON =
  'bg-Neutral-5 text-surface-1 [html[data-theme=\'dark\']_&]:bg-white [html[data-theme=\'dark\']_&]:text-[#0b0a14]'

export const TAB_OFF =
  'bg-Neutral-2 text-Neutral-4 [html[data-theme=\'dark\']_&]:bg-white/[0.08] [html[data-theme=\'dark\']_&]:text-white/65'

export const TAB_COUNT_ON = 'text-surface-1/50 [html[data-theme=\'dark\']_&]:text-[#0b0a14]/50'
export const TAB_COUNT_OFF = 'text-Neutral-4/60 [html[data-theme=\'dark\']_&]:text-white/40'

export const NOTCH = 'bg-Neutral-5 [html[data-theme=\'dark\']_&]:bg-white/70'

export const TAB_PILL =
  'inline-flex h-8 shrink-0 items-center gap-1.5 rounded-full px-3 text-xs font-bold shadow-[0_10px_26px_rgba(0,0,0,0.16)] backdrop-blur transition-all duration-300 md:h-9 md:gap-2 md:px-4 md:text-sm'
